import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { "format-key": "0" }
const _hoisted_2 = { class: "_mb-3 _mt-0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")
  const _component_base_button = _resolveComponent("base-button")
  const _component_continue_as_guest_account_benefit_list = _resolveComponent("continue-as-guest-account-benefit-list")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createBlock(_component_box, null, {
    default: _withCtx(() => [
      _createVNode(_component_localize, {
        tag: "p",
        resource: _ctx.Resources.Account.ContinueAsGuestDescription
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.platformName), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["resource"]),
      ($props.actionUrl)
        ? (_openBlock(), _createBlock(_component_base_button, {
            key: 0,
            theme: "accent",
            shape: "soft",
            class: "_my-3 _w-100",
            onClick: _withModifiers($options.onSubmit, ["prevent"]),
            "data-qa": "continue-as-guest-button:ContinueAsGuest"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.Account.ContinueAsGuestButtonLabel), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.Resources.Account.ContinueAsGuestBenefitsListHeader), 1 /* TEXT */),
      _createVNode(_component_continue_as_guest_account_benefit_list),
      _createTextVNode(" " + _toDisplayString(_ctx.Resources.Account.ContinueAsGuestBenefitMoreLabel) + " ", 1 /* TEXT */),
      _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
    ]),
    _: 1 /* STABLE */
  }))
}